import { urlConfig } from '@/config';
import type { UserData } from '@/contexts/auth-context';

export class AuthAPI {
  private static async fetch<T>(
    endpoint: string,
    options: RequestInit,
  ): Promise<T> {
    const response = await fetch(`${urlConfig.authUrl}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`Authentication failed: ${response.statusText}`);
    }

    return response.json();
  }

  static async authenticateGoogle(
    credentialsJWT: string,
  ): Promise<{ user: UserData; access_token: string }> {
    return this.fetch('/login', {
      method: 'POST',
      body: JSON.stringify({ credentials_jwt: credentialsJWT }),
    });
  }

  static async validateSession(token: string): Promise<UserData> {
    return this.fetch('/validate', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
